import React from 'react';
import { StyledEmptyScreen } from './EmptyScreen.styles';
import Button from '../../molecules/Button';

const EmptyScreen = ({
    illustration,
    header,
    tag,
    title,
    description,
    buttonLabel,
    buttonIcon: ButtonIcon,
    onButtonClick,
    children,
    height,
    btnWidth,
    disabledButton,
    buttonId,
}) => {
    return (
        <StyledEmptyScreen $height={height}>
            <div className="empty-screen-holder">
                <div className="empty-screen-content">
                    <div className="empty-screen-content-inner">
                        {header && (
                            <div className="head">
                                <div className="img-holder">
                                    <img src={illustration} alt="empty screen" />
                                </div>
                                <div className="text-holder">
                                    <h4>{header.title}</h4>
                                    <span className="head-text">{header.subtitle}</span>
                                </div>
                                {tag && <div className="tag">{tag}</div>}
                            </div>
                        )}
                        {children}
                    </div>
                </div>

                <h3 className="last-heading">{title}</h3>
                <p className="description">{description}</p>

                {buttonLabel && (
                    <div className="btn-holder">
                        <Button id={buttonId} width={btnWidth ? btnWidth : "250px"} rounded onClick={onButtonClick} disabled={disabledButton}>
                            {ButtonIcon && <ButtonIcon size={20} />}
                            {buttonLabel}
                        </Button>
                    </div>
                )}
            </div>
        </StyledEmptyScreen>
    );
};

export default EmptyScreen;